/* TX press marquee: scrollLeft only, nothing inserted, so the Judge Me MutationObserver is never fed */
(function () {
  'use strict';

  var REDUCED = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)');

  function init(scroller) {
    if (scroller.__txPress) return;
    scroller.__txPress = true;
    var TX_PRESS_BUILD = '20260826-r1';

    var speed = parseFloat(scroller.getAttribute('data-speed')) || 30; /* px/s */
    var MQ = window.matchMedia('(min-width: 768px)');
    var scrollD = scroller.getAttribute('data-scroll-d') !== 'false';
    var scrollM = scroller.getAttribute('data-scroll-m') === 'true';
    var paused = false;
    var loopWidth = 0;
    var last = null;
    var pos = 0; /* fractional scroll position - the DOM copy is rounded */

    function measure() {
      var originals = scroller.querySelectorAll('.tx-press__logo:not(.tx-press__clone)');
      var clones = scroller.querySelectorAll('.tx-press__clone');
      if (!originals.length || !clones.length) { loopWidth = 0; return; }
      /* first original to first clone = one set plus the seam gap = loop length */
      loopWidth = clones[0].offsetLeft - originals[0].offsetLeft;
    }

    function tick(now) {
      if (REDUCED && REDUCED.matches) { last = null; requestAnimationFrame(tick); return; }
      if (last === null) { last = now; requestAnimationFrame(tick); return; }
      var dt = (now - last) / 1000;
      last = now;
      var active = MQ.matches ? scrollD : scrollM;
      if (!paused && active && loopWidth > 0 && dt < 0.25) {
        /* accumulate in pos: scrollLeft snaps to whole pixels, so re-reading it freezes sub-pixel steps */
        pos += speed * dt;
        if (pos >= loopWidth) pos -= loopWidth;
        scroller.scrollLeft = pos;
      } else {
        pos = scroller.scrollLeft;
      }
      requestAnimationFrame(tick);
    }

    scroller.addEventListener('pointerenter', function () { paused = true; });
    scroller.addEventListener('pointerleave', function () { paused = false; });
    scroller.addEventListener('focusin', function () { paused = true; });
    scroller.addEventListener('focusout', function () { paused = false; });

    var ro = 'ResizeObserver' in window ? new ResizeObserver(measure) : null;
    if (ro) ro.observe(scroller); else window.addEventListener('resize', measure);

    if (document.readyState === 'complete') measure();
    else window.addEventListener('load', measure);
    measure();
    requestAnimationFrame(tick);
  }

  function boot() {
    document.querySelectorAll('[data-tx-press-scroller]').forEach(init);
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot);
  else boot();

  document.addEventListener('shopify:section:load', boot);
})();
